import { render } from "./CouponsList.vue?vue&type=template&id=e2e093f0"
import script from "./CouponsList.vue?vue&type=script&lang=js"
export * from "./CouponsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__